import {EmailTemplateCreateDto} from "@common/dto/email-template/create-dto";
import {EmailTemplateListDto} from "@common/dto/email-template/list";
import {EmailTemplateUpdateDto} from "@common/dto/email-template/update";
import {clientTransformed} from "@common/utils/rest";
import {HttpSuccessDto} from "@common/dto/http";

const URL_PREFIX = 'api/emailTemplates';

const getUrl = (path: string) => {
    return `${URL_PREFIX}/${path}`;
};

export const updateEmailTemplates = async (data: Array<EmailTemplateUpdateDto>) => {
    return clientTransformed({
        path: getUrl(`update`),
        method: 'POST',
        entity: data
    })
};


export const deleteEmailTemplate = (id: Array<number>) => {
    return clientTransformed({
        path: getUrl(`delete`),
        method: 'POST',
        entity: {ids: id}
    })
};

export const checkQuestionnaires = (id: Array<number>): Promise<Map<number, Array<string>>> => {
    return clientTransformed({
        path: getUrl(`checkQuestionnaires`),
        method: 'POST',
        entity: {ids: id}
    }).then(
        (response: HttpSuccessDto<Map<number, Array<string>>>) => {
            return new Map(Object.entries(response.entity));
        },
    );
};

export const createEmailTemplate = async (data: EmailTemplateCreateDto) => {
    return clientTransformed({
        path: getUrl(`create`),
        method: 'POST',
        entity: data
    })
};

export const copyEmailTemplate = async (data: EmailTemplateUpdateDto) => {
    return clientTransformed({
        path: getUrl(`copy`),
        method: 'POST',
        entity: data
    })
};